/* 
  Custom Luxury Collection Logic
  Save under assets/collection.js 
*/

document.addEventListener('DOMContentLoaded', function() {
  initSubcollectionCarouselScroll();
  initColorSwatchesTrigger();
});

/**
 * Centered Carousel scroll helpers and touch event handlers
 */
function initSubcollectionCarouselScroll() {
  const carousel = document.querySelector('.categories-carousel');
  if (!carousel) return;

  // Active category centering scroll behavior
  const activeItem = carousel.querySelector('.category-item.active');
  if (activeItem) {
    const halfWidth = carousel.clientWidth / 2;
    const itemOffset = activeItem.offsetLeft;
    const itemWidth = activeItem.clientWidth / 2;
    carousel.scrollTo({
      left: itemOffset - halfWidth + itemWidth,
      behavior: 'smooth'
    });
  }
}

/**
 * Variant image triggers when swatch option elements are hovered/clicked
 */
function initColorSwatchesTrigger() {
  const cards = document.querySelectorAll('.product-card');
  
  cards.forEach(card => {
    const swatches = card.querySelectorAll('.swatch-item');
    const primaryImg = card.querySelector('.product-card__image-primary');
    
    if (!swatches.length || !primaryImg) return;
    
    swatches.forEach(swatch => {
      const handleTrigger = () => {
        // Toggle active class representation
        swatches.forEach(s => s.classList.remove('active'));
        swatch.classList.add('active');
        
        // Swap primary image sources to dynamic variant image source if exists
        const variantImgUrl = swatch.getAttribute('data-variant-image');
        if (variantImgUrl && variantImgUrl !== '') {
          primaryImg.setAttribute('src', variantImgUrl);
          primaryImg.setAttribute('srcset', variantImgUrl);
        }
      };
      
      swatch.addEventListener('click', handleTrigger);
      swatch.addEventListener('mouseenter', handleTrigger);
    });
  });
}
